import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AuthService } from '../../shared/security/auth.service';
import { SaveService } from '../../shared/services/save.service';
import { UserService } from '../../shared/services/user.service';
import { User, IFavorite } from '../../shared/model/user';
import { Router } from '@angular/router';

@Component({
  selector: 'user-create',
  templateUrl: './user-create.component.html',
  styleUrls: ['./user-create.component.css']
})
export class UserCreateComponent implements OnInit {

  invalidUserType: boolean = false;
  emailAlreadyInUse: boolean;
  weekPassword: boolean;
  operationNotAllowed: boolean;
  invalidEmail: boolean;
  form: FormGroup;

  
  constructor(private authService: AuthService,
    private saveService: SaveService,
    private userService: UserService,
    private router: Router) { }

  ngOnInit() {
    this.saveService.setTitle(`Créer un compte`);
  }

  onOutForm(form: FormGroup) {
    this.form = form;
    if (this.form.value.userType) {
      this.invalidUserType = false;
    }
  }

  register() {
    if (this.form.value.userType) {
      this.authService.signUp(this.form.controls.emailGroup.value.email, this.form.controls.passwordGroup.value.password)
        .subscribe(
        val => this.save(val.uid),
        err => this.handleError(err.code)
        );
    } else {
      this.invalidUserType = true;
    }
  }

  handleError(error) {
    if (error == "auth/email-already-in-use") {
      this.emailAlreadyInUse = true
    } else if (error == "auth/invalid-email") {
      this.invalidEmail = true
    } else if (error == "auth/operation-not-allowed") {
      this.operationNotAllowed = true
    } else if (error == "auth/weak-password") {
      this.weekPassword = true
    }
  }

  formatUser(value, uid): User {
    const userType = (value.userType === "1" ? "ADMIN" : "NORMAL");
    const date = new Date().toDateString();
    const favorite: IFavorite[] = [{ institution: "Created User", type: date }];
    return new User(uid,
      userType,
      value.firstName,
      value.lastName,
      value.address,
      value.city,
      value.prov,
      value.country,
      value.postalCode,
      value.phoneHouse,
      value.phoneMobile,
      value.phoneWork,
      value.phoneExt,
      value.emailGroup.email,
      value.notifyBySms,
      value.notifyByEmail,
      value.notifyByPhone,
      value.notifyByPush,
      favorite)
  }

  save(uid) {

    const user = this.formatUser(this.form.value, uid);
    this.userService.saveUser(uid, user)
      .subscribe(
      () => {
        this.saveService.setUser(user);
        if (user.userType === "ADMIN") {
          this.router.navigate(['choice-responsible']);
        } else {
          this.router.navigate(['choice-student']);
        }
      },
      err => console.error(`error creating user ${uid} error = ${err}`)
      );

  }

  resetForm() {
    this.form.reset();
    Object.keys(this.form.controls).forEach(key => {
      this.form.controls[key].setErrors(null)
    });
  }

  onCancel = () => {
    this.router.navigate(['login']);
  }

}



// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/app/users/user-create/user-create.component.ts